'use strict';

angular.module('app').directive('shareAffiliate', function (utils, Request) {
    return {
        restrict: 'AE',
        link: function (_, element) {
            return Request.post('url-shortner/', {
                longUrl: utils.generateAffiliateUrl()
            }).then(function(res) {
                return encodeURIComponent(res.data.shortUrl)
            }).then(function(affiliateLink) {
                element.html('<div class="share-block">' +
                    '<a target="_blank" href="https://www.facebook.com/sharer.php?u=' + affiliateLink + '"><i class="font-icons fb-icon"></i>Facebook</a>' +
                    '<a target="_blank" href="https://twitter.com/intent/tweet?url=' + affiliateLink + '"><i class="font-icons twitter-icon"></i>Twitter</a>' +
                    '<a target="_blank" href="https://plus.google.com/share?url=' + affiliateLink + '"><i class="font-icons icon-google-plus"></i>Google Plus</a>' +
                    '<a target="_blank" href="https://www.pinterest.com/pin/create/button/?url=' + affiliateLink + '&media=https%3A//s.diviac.com/travel_dist/images/padi_travel_social_default.jpg&description="><i class="font-icons icon-pinterest"></i>Pinterest</a>' +
                    '<a target="_blank" href="https://www.linkedin.com/shareArticle?mini=true&url=' + affiliateLink + 'title=PADI%20Travel&summary=PADI%20Travel&source="><i class="font-icons icon-linkedin"></i>Linkedin</a>' +
                '</div>');
            });
        }
    };
});